import { SzHfZoneKey } from '@ui';

export interface HitFactorInput {
  readonly hitsA: number | null;
  readonly hitsC: number | null;
  readonly hitsD: number | null;
  readonly hitsM: number | null;
  readonly hitsNS: number | null;
  readonly timeSeconds: number | null;
}

export const computeHitFactor = (input: HitFactorInput): number | null => {
  if (
    input.timeSeconds === null ||
    input.timeSeconds <= 0 ||
    input.hitsA === null ||
    input.hitsC === null ||
    input.hitsD === null ||
    input.hitsM === null ||
    input.hitsNS === null
  ) {
    return null;
  }
  const points: number = input.hitsA * 5 + input.hitsC * 3 + input.hitsD * 1 - input.hitsM * 10 - input.hitsNS * 10;
  return points > 0 ? points / input.timeSeconds : 0;
};

export const initShotAllocation = (shotsCount: number): readonly SzHfZoneKey[] => {
  if (shotsCount <= 0) return [];
  return Array.from({ length: shotsCount }, (): SzHfZoneKey => 'A');
};

export const allocateShotTo = (zones: readonly SzHfZoneKey[], target: SzHfZoneKey): readonly SzHfZoneKey[] => {
  if (target === 'A') {
    return revertLastShot(zones);
  }
  const firstAIndex: number = zones.indexOf('A');
  if (firstAIndex === -1) return zones;
  const next: SzHfZoneKey[] = [...zones];
  next[firstAIndex] = target;
  return next;
};

export const revertLastShot = (zones: readonly SzHfZoneKey[]): readonly SzHfZoneKey[] => {
  for (let i: number = zones.length - 1; i >= 0; i--) {
    if (zones[i] !== 'A') {
      const next: SzHfZoneKey[] = [...zones];
      next[i] = 'A';
      return next;
    }
  }
  return zones;
};

export const countByZone = (zones: readonly SzHfZoneKey[]): Readonly<Record<SzHfZoneKey, number>> => {
  const counts: Record<SzHfZoneKey, number> = { A: 0, C: 0, D: 0, M: 0, NS: 0 };
  for (const zone of zones) {
    counts[zone] = counts[zone] + 1;
  }
  return counts;
};

export const zonesToHitFactorInput = (zones: readonly SzHfZoneKey[], timeSeconds: number | null): HitFactorInput => {
  const counts: Readonly<Record<SzHfZoneKey, number>> = countByZone(zones);
  return {
    hitsA: counts.A,
    hitsC: counts.C,
    hitsD: counts.D,
    hitsM: counts.M,
    hitsNS: counts.NS,
    timeSeconds
  };
};
